export const providerIds = {
  FABROS: 1,
  XFLOW: 2,
};
